import pages from './pages'

// todo delete
import Vue from 'vue'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'
import wysiwyg from 'vue-wysiwyg'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import NTextarea from 'components/textarea/Index'

Vue.use(VueToast)
//

export default {
  app: {
    baseUrl: '/',
    beforeCreate: (vue) => {
      vue.use(wysiwyg, {
        forcePlainTextOnPaste: true,
        hideModules: { 'image': true, },
      })
      vue.component('n-textarea', NTextarea)
    },
  },
  
  api: {
    servers: {
      default: {
        dev: 'http://127.0.0.1:8000/api/',
        prod: 'https://academy.aifc.kz/api/',
      },
    },
    init: () => {
      $app.api.config({})
    },
    callback: (response) => {
      if (!response.data.content) {
        response.data.content = response.data.data
      }
      if (response.data.message) {
        Vue.$toast.open({
          message: response.data.message,
          type: 'success',
          position: 'top-right',
          duration: 5000,
        })
      }
      return response
    },
    catch: (error) => {
      if (error.response?.status === 401) {
        $app.auth.logout()
      } else if (error.response?.status === 422) {
        const message = error.response?.data.message
        const data = error.response?.data.data
        let errors = ''
        $n.each(data, (item) => {
          errors += item[0]
        })
        Vue.$toast.open({
          message: 'Ошибка: ' + message + ', ' + errors,
          type: 'error',
          position: 'top-right',
          duration: 5000,
        })
      } else {
        const message = error.response?.data.message || 'Сервер недоступен'
        Vue.$toast.open({
          message: 'Ошибка: ' + message,
          type: 'error',
          position: 'top-right',
          duration: 5000,
        })
      }
      throw error
    },
    dataKey: 'data.content',
  },
  
  data: {
    preload: false,
  },
  
  router: {
    pageTitle(name, type) {
      return `app.${type}.${name}`
    },
    titles() {
      return pages()
    },
    navigation() {
      return [
      ]
    },
  },
  
  auth: {
    api: (l, p) => $api.auth.login(l, p),
    getToken: (response) => {
      return response.data.content.token
    },
    getUser: (response) => {
      return response.data.content.user
    },
  },
  
  locale: {
    api: {
      locales: () => {},
      elements: () => {},
      change: () => {},
    },
  },
  
  form: {
    input: (self, name, type, form) => {
      if (type === 'select') {
        return {
          name,
          value: self.$form.get(name, form),
          'update:value': (value) => self.$form.set(name, value, form),
          'item-value': 'id',
          'option-title': 'title',
          'selected-title': 'title',
          danger: self.$form.errors(name, form),
          text: self.$form.editable(form) === false,
        }
      }
      if (type === 'textarea') {
        return {
          name,
          html: self.$form.get(name, form),
          danger: self.$form.errors(name, form),
          text: self.$form.editable(form) === false,
        }
      }
      return {
        name,
        value: self.$form.get(name, form),
        input: (value) => self.$form.set(name, value, form),
        danger: self.$form.errors(name, form),
        text: self.$form.editable(form) === false,
      }
    },
    validations: {
      customRule(value) {
        return value.length === 14
      },
    },
    messages: {
      customRule: 'Ошибка',
    },
  },
}
